"use strict";
/**
 * Permissions / Ban Database Record Types
 *
 * Backs the platform-wide account ban system (see
 * .kiro/specs/account-ban-system). A single per-user record
 * (PK: user#{identityId}, SK: permissions) holds two independent ban slots —
 * a long-term standing ban and a short-term temporary ban.
 *
 * SERVER-SIDE ONLY: the PermissionsRecord is never returned raw in any API
 * response. Backend mutation endpoints read it to enforce restrictions and the
 * secure own-profile endpoint reads it to derive minimal UI flags. The public
 * profile endpoints never touch it, so a user's ban state can never be exposed
 * to any other user.
 */
Object.defineProperty(exports, "__esModule", { value: true });
